// extracted by mini-css-extract-plugin
export default {"slot":"DutySlot_slot__BXOn1"};